import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class SentryService {
  log(error: string | Error | unknown) {
    try {
      Sentry.captureException(error);
    } catch (err) {
      console.error('Failed to log to Sentry:', err);
    }
    console.error(error);
  }
}
